/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import AuditSheet from './components/AuditSheet';
import AuditSheetFooter from './components/AuditSheetFooter';
import Topbar from './components/Topbar';
import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  useBoolean,
} from '@chakra-ui/react';
import AppColors from '../../constants/AppColors';
import { withProvider } from '../../hoc/withProvider';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AuditSheetProvider, {
  AuditSheetContext,
} from '../../providers/AuditSheetProvider';
import { createEmptyObject } from './components/createEmptyObject';
import { AWAITING_AUDIT, CLIENT } from '../../constants/constants';
import { sanitize } from './components/sanitize';
import SubmitModal from './components/SubmitModal';
import ROUTES from '../../constants/Routes';
import { useToastr } from '@laxmimanogna/code-quick-components';
import { successToast } from '../../components/successToast';
import { submitRule } from './components/submitRules';
import CommentBox from './components/CommentBox';
import { createEmptyColumn } from '../../utils/auditsheetCreateEmptyProps.utils.js';
import { arrangeData } from '../../utils/auditsheetArrangeData.utils';
import { AccessDenied } from '../dashboard/components/AccessDenied.js';
import { toTitleCase } from '../../utils/common.utils';
import { DashboardContext } from '../../providers/DashboardProvider.js';
import React from 'react';
import { format } from 'date-fns';
import { useCallback } from 'react';

const AuditSheetContainer = ({ view, batch }) => {
  const auditSheetCount = Math.ceil(window.innerHeight / 24);

  const domEl = useRef(null);
  const topbar = useRef(null);
  const notesDrawerRef = useRef(null);
  const footer = useRef(null)
  const dashboardContext = useContext(DashboardContext);
  const oldFilter = JSON.parse(localStorage.getItem('selectedFilter'));
  const [filter, setFilter] = useState(oldFilter ? oldFilter : 'month');
  const [searchParams] = useSearchParams();
  const filterByDate = searchParams.get('filterByDate') ?? false;

  const dateFilter = useMemo(() => {
      let queryParams = {}
      queryParams['label'] = JSON.parse(localStorage.getItem('selectedFilter'));
      queryParams = {...queryParams, ...JSON.parse(localStorage.getItem('customDateFilter'))}
      return queryParams;
    }, []);
  
    const getFilterParams = (filterParams) => {
      const queryParams = {};
      const { start_date, end_date, label } = filterParams;
      if (label) queryParams['filter'] = label.toLowerCase();
  
      if (filterParams.label.toLowerCase() === 'custom') {
        queryParams['start_date'] = format(new Date(start_date), 'yyyy-MM-dd')
        queryParams['end_date'] = format(new Date(end_date), 'yyyy-MM-dd');
        if (filterParams.previous_start_date) {
          queryParams['previous_start_date'] = format(new Date(filterParams.previous_start_date), 'yyyy-MM-dd');
          queryParams['previous_end_date'] = format(new Date(filterParams.previous_end_date), 'yyyy-MM-dd');
        }
        delete queryParams['filter'];
      }
      return queryParams;
    };

  

  const [isLoading, ilState] = useBoolean(false);

  const { batchId, uploadId, type, rendererId } = useParams();
  const navigate = useNavigate();
  const toast = useToastr();
  const [isOpen, ioState] = useBoolean(false);
  const [lastSaved, setLastSaved] = useState('');
  const [sheets, setSheets] = useState([
    {
      index: 1,
      sheet_name: 'Sheet1',
      data: createEmptyObject(auditSheetCount),
    },
  ]);

  const [unfilteredSheets, setUnfilteredSheets] = useState(null);
  const [activeSheetIndex, setActiveSheetIndex] = useState(0);
  const [scale, setScale] = useState(1);
  const [isCommentOpen, icoState] = useBoolean(false);
  const [metaData, setMetaData] = useState({});
  const [isSubmitDisabled, setSubmitDisabled] = useState(true)
  const [errMsg, setErrMsg] = useState(null)

  const auditSheetContext = useContext(AuditSheetContext);
  const {
    getAuditSheet,
    getBatchAuditSheet,
    currentUpload,
    getIndustryCodes,
    getICDCodes,
    getModifiers,
    getUsers,
    users,
    getAllUsers,
    getCommentFlag,
    getAuditUpload,
    providerOptions,
    isAuditSheetLoading,
    isAccessDenied,
    getComments,
    setSheetData,
    setBatchChartIds,
    setChartBatchId,
    loadBatchRebuttalStatus,
  } = auditSheetContext;

  const [coords,setCoords]=useState({x:0,y:0})

  const sheetNames = sheets.map(s => s?.sheet_name);
  const DEFAULT_RENDERING_OPTION = toTitleCase("All Renderers");
  const [rendererOptions, setRendererOptions] = useState({});
  const [selectedRenderer, setSelectedRenderer] = useState(0);
  const [batchName, setBatchName] = useState(null);
  
  const SINGLE_AUDIT_SHEET_ROW_FILTER = useCallback(row => {
    return (rendererOptions[selectedRenderer] === DEFAULT_RENDERING_OPTION || row.rendering === rendererOptions[selectedRenderer]);
  }, [selectedRenderer, rendererOptions])
  

  useEffect(() => {
    if (rendererId) {
      setSelectedRenderer(rendererId);
    }
  }, [rendererId]);

  useEffect(() => {
    const map = {};
    sheets.forEach(sheet => {
      sheet.data.forEach((row, index) => {
        if (row.id) map[row.id] = index + 1;
      });
    });
    setSheetData(map);
  }, [sheets]);

  const getUpload = async () => {
    if (batch) {
      getSheet();
      return;
    }
    if (uploadId) {
      const res = await getAuditUpload(uploadId);
      if (res?.error) {
        setErrMsg(res.error);
        return;
      }
      setLastSaved(res.updated_date);
    }
  };

  const onCommentClick = (selection, dimension, comment, canRebuttal,columnData,selectedCol) => {
    const colIndex=selection[0].start.col
    const rowIndex=selection[0].start.row
    const selectedColumnName = columnData[colIndex]?.data;
    // Use functional update to preserve selectedRowData set by afterSelectionEnd
    setMetaData(prev => ({ ...prev, ...dimension, selection, canRebuttal, selectedColumnName, rowIndex }));

    if (dimension.pageX && dimension.pageY) {
      setCoords({ x: dimension.pageX, y: dimension.pageY });
    }

    comment && icoState.on();
  };

  const onZoom = value => {
    let temp = 1;
    if (value >= 50) {
      temp = (2 * value) / 100;
    } else if (value === 0) {
      temp = 0.3;
    } else {
      temp = (value / 100) * 2;
    }
    setScale(temp);
  };


  useEffect(() => {
    if(!isAccessDenied){
      if (uploadId || batchId) {
        getCommentFlag({ uploadId, batchId })
      }
    }
  }, [uploadId, batchId, isAccessDenied])

  const filterData = (data, type) => {
    switch (type) {
        case 'rvu':
            return data.filter(item => item.audited_dollar_value !== item.provider_dollar_value);
        case 'upcoded':
            return data.filter(item => item.audited_dollar_value > item.provider_dollar_value);
        case 'downcoded':
            return data.filter(item => item.audited_dollar_value < item.provider_dollar_value);
        case 'modifier':
            return data.filter(item => item.audited_dollar_value !== item.provider_dollar_value);
        default:
            return data;
    }
};

  const removeDateFilter = () => {
    let copy = JSON.parse(JSON.stringify(unfilteredSheets));
    copy.forEach((val, idx) => {
      for (let i = 0; i < val.data.length ; i++) {
        if (!val.data[i].id) {
          break;
        }
        delete val.data[i].within_date;
      }
    });
    setSheets(copy);
  }

  const filterSheetsByDate = () => {
    if (!unfilteredSheets) {
      return;
    }
    let copy = JSON.parse(JSON.stringify(unfilteredSheets));
    copy.forEach((val, idx) => {
      let empty_el = 0;
      for (let i = val.data.length - 1; i >= 0 ; i--) {
        if (!val.data[i].id) {
          continue;
        }
        if (!val.data[i].within_date) {
          val.data.splice(i, 1);
          empty_el++;
        } else {
          delete val.data[i].within_date;
        }
      }
      val.data.push(createEmptyObject(empty_el));
    });

    setSheets(copy);
  }

  useEffect(() => {
    if (filterByDate) {
      filterSheetsByDate();
    } else {
      if (unfilteredSheets) {
        setSheets(unfilteredSheets);
      }
      
    }
  }, [unfilteredSheets])
    

  const getSheet = async () => {
    if (
      uploadId &&
      Object.keys(currentUpload) &&
      currentUpload.status !== AWAITING_AUDIT && !batch
    ) {
      const response = await getAuditSheet(uploadId, {...getFilterParams(dateFilter), filter_by_date: true});
      if (response?.error) {
        return;
      }
      if (response.length) {
        setBatchName(response[0].batch_name);
        // Store batch ID so the notes drawer can also fetch batch-level notes in chart view
        const sheetBatchId = response[0].batch_id || response[0].batch;
        if (sheetBatchId) setChartBatchId(sheetBatchId);
        const updated = response.map((res, i) => {
          const filteredData = (typeof type === 'string' && type.length > 0) ? filterData(res.data, type) : res.data;
          const _reDestructuredData = createEmptyColumn(filteredData);
      
          let rendererOptions = {0: DEFAULT_RENDERING_OPTION};

          for (let i = 0; i < filteredData.length; i++) {
            if (!filteredData[i].rendering?.id) {
              continue;
            }
            if (filteredData[i].rendering.id in rendererOptions) {
              continue;
            }
            rendererOptions[filteredData[i].rendering.id] = toTitleCase(filteredData[i].rendering.first_name + " " + filteredData[i].rendering.last_name);
          }

          setRendererOptions(rendererOptions);

          const reDestructuredData = _reDestructuredData.map(sd => {
            const tempObj = { ...sd, ...sd.additional_attributes };
            tempObj['audited_cpt'] = tempObj['audited_code'];
            delete tempObj.additional_attributes;
            delete tempObj?.audited_code;
            if (tempObj?.enc_dt) {
              const parts = tempObj.enc_dt.split('-');
              const year = parseInt(parts[0], 10);
              const month = parseInt(parts[1], 10) - 1;
              const day = parseInt(parts[2], 10);
              const parsedDate = new Date(year, month, day);

              if (!isNaN(parsedDate.getTime())) {
                const formattedDate = `${(parsedDate.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, '0')}-${parsedDate.getFullYear()}`;
                tempObj.enc_dt = formattedDate;
              }
            }
            if (!tempObj.hasOwnProperty('icd_agree')){
              tempObj['icd_agree'] = null;
            }
            if (!tempObj.hasOwnProperty('icd_disagree')){
              tempObj['icd_disagree'] = null;
            }
            if (filterByDate) {
              tempObj['within_date'] = sd.within_date;
            }
            return tempObj;
          });

          
          const _arrangeData = arrangeData(reDestructuredData).map((val, idx) => {
            return {...val, within_date: reDestructuredData[idx].within_date}
          });

          const updatedData = [
            ..._arrangeData,
            ...createEmptyObject(auditSheetCount - res.data.length),
          ];


          return {
            ...res,
            index: i + 1,
            data: updatedData,
          };

        });
        setUnfilteredSheets(updated);
        // now the useEffect for unfilteredSheets will be called and the filtering by date will happen
        
        
        disableSubmitFunc(response);

      }
    } else {
      const response = await getBatchAuditSheet(batchId, rendererId);
      if (response?.error) {
        setErrMsg(response.error);
        return;
      }

      if (response.length) {
        setBatchName(response[0].batch_name);
        const updated = response.map((res, i) => {

          const _reDestructuredData = createEmptyColumn(res.data);

          const reDestructuredData = _reDestructuredData.map(sd => {
            const tempObj = { ...sd, ...sd.additional_attributes };
            tempObj['audited_cpt'] = tempObj['audited_code'];
            delete tempObj.additional_attributes;
            delete tempObj?.audited_code;

            if (tempObj?.enc_dt) {
              const parts = tempObj.enc_dt.split('-');
              const year = parseInt(parts[0], 10);
              const month = parseInt(parts[1], 10) - 1;
              const day = parseInt(parts[2], 10);
              const parsedDate = new Date(year, month, day);

              if (!isNaN(parsedDate.getTime())) {
                const formattedDate = `${(parsedDate.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, '0')}-${parsedDate.getFullYear()}`;
                tempObj.enc_dt = formattedDate;
              }
            }
            if (!tempObj.hasOwnProperty('icd_agree')){
              tempObj['icd_agree'] = null
            }
            if (!tempObj.hasOwnProperty('icd_disagree')){
              tempObj['icd_disagree'] = null
            }
            return tempObj;
          });


          const _arrangeData = arrangeData(reDestructuredData);


          const updatedData = [
            ..._arrangeData,
            ...createEmptyObject(auditSheetCount - res.data.length),
          ];
          return {
            ...res,
            index: i + 1,
            data: updatedData,
          };
        });

        setSheets(updated);
        disableSubmitFunc(response);

        // Collect unique chart upload IDs from batch row data so the notes
        // drawer can fetch chart-specific notes alongside batch notes.
        const chartIdSet = new Set();
        updated.forEach(sheet => {
          sheet.data.forEach(row => {
            if (row.chart_id) chartIdSet.add(row.chart_id);
          });
        });
        const chartIds = [...chartIdSet];
        setBatchChartIds(chartIds);
        loadBatchRebuttalStatus(batchId, chartIds);

      }
    };
  }

  useEffect(() => {
    getUpload();
  }, []);

  useEffect(() => {
    if(!isAccessDenied){
      getIndustryCodes();
      getICDCodes();
      getModifiers();
      getUsers()
      getAllUsers()
      if (uploadId) {
        auditSheetContext.fetchProviderDropdown(uploadId)
      }
      auditSheetContext.fetchResponseAuditIssues();
    }
  }, [isAccessDenied]);


  useEffect(()=>{
    // performing get sheet for single audit sheet view because batch already has their sheet called
    if (!isAccessDenied && uploadId) {
      getSheet();
    }

  },[uploadId, isAccessDenied])

  // const onAuditSubmit = async () => {
  //   // call audithour
  //   await auditSheetContext.monitorAuditHour(batchId);
  //   // create audit sheet
  //   const sanitizedSheet = sanitize(sheets, providerOptions);
  //   const response = await auditSheetContext.updateAuditSheet(
  //     sanitizedSheet,
  //     batchId
  //   );
  //   if (response) {
  //     ioState.off();
  //     navigate(ROUTES.DASHBOARD);
  //     const toastProps = {
  //       header: 'Success!',
  //       description: `${'Document submitted for review.'}`,
  //     };
  //     successToast(toast, toastProps);
  //   }
  // };

  const updateAuditSheet = async () => { };

  const disableSubmitFunc = () => {
    const sanitizedSheet = sanitize(sheets, providerOptions);
    if (sanitizedSheet.every(sheet => sheet.data.length === 0)) {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(submitRule(sanitizedSheet));
    }
  };

  const addNewSheet = async () => {
    const updatedSheets = [
      ...sheets,
      {
        index: sheets.length + 1,
        data: createEmptyObject(auditSheetCount),
        sheet_name: `Sheet${sheets.length + 1}`,
      },
    ];
    setSheets([...updatedSheets]);
    setActiveSheetIndex(sheets.length);
  };



  const changeSheetName = async (index, name) => {
    sheets[index] = { ...sheets[index], sheet_name: name };
    setSheets([...sheets]);
    const sanitizedSheet = sanitize(sheets, providerOptions);
    await auditSheetContext.createAuditSheet(sanitizedSheet, batchId);
  };

  const onLeftNavigate = () => {
    if (activeSheetIndex > 0) {
      setActiveSheetIndex(activeSheetIndex - 1);
    }
  };

  const onRightNavigate = () => {
    if (activeSheetIndex < sheets.length - 1) {
      setActiveSheetIndex(activeSheetIndex + 1);
    }
  };

  const updateSheet = sheetData => {
    sheets[activeSheetIndex].data = sheetData;
    setSheets([...sheets]);
    disableSubmitFunc(sheets)

  };

  const removeRows = (rowIndexes) => {
    const data = sheets[activeSheetIndex].data.filter((obj, i) => !rowIndexes.includes(i));
    sheets[activeSheetIndex].data = data;
    setSheets([...sheets]);
    disableSubmitFunc(sheets)

  }

  const onDeleteSheet = async index => {
    if (sheets.length > 1) {
      let sheetIndex = 1;
      let newSheet = [];
      sheets.map((p, i) => {
        if (index !== i) {
          newSheet.push({ ...p, index: sheetIndex });
          sheetIndex = sheetIndex + 1;
        }
      });
      setSheets([...newSheet]);
      if (activeSheetIndex === index && index > 0) {
        const data = activeSheetIndex - 1;
        setActiveSheetIndex(data);
      }
      const sanitizedSheet = sanitize(newSheet, providerOptions);
      await auditSheetContext.createAuditSheet(sanitizedSheet, batchId);
    }
  };

  const onRebuttalClick = async () => {
    const rowData = metaData.selectedRowData;
    const selection = metaData.selection;

    if (!rowData?.id) {
      toast.showError({ description: 'Please select a valid row to add a rebuttal.' });
      return;
    }
    if (selection && selection[0]?.start.row !== selection[0]?.end.row) {
      toast.showError({ description: 'Please select a single row to add a rebuttal.' });
      return;
    }
    const chartId = rowData?.chart_id;
    auditSheetContext.setComments([]);
    await auditSheetContext.getComments({ batchId, uploadId: uploadId || chartId, row: rowData.id });
    icoState.on();
  };

  const onOpenNotes = (obj) => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1
        })
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: sheets[activeSheetIndex].sheet_name,
          page: 1
        })
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        uploadId,
        batchId,
        sheet_name: sheets[activeSheetIndex].sheet_name,
        reverse: true,
        page: 1
      })
    }

  }

  function handleSheetClick(e) {
    setCoords({
      x:e.clientX,
      y:e.clientY
    })
  }
  
 

  return (
    <AccessDenied loading={isAuditSheetLoading} accessDenied={isAccessDenied} errMsg={errMsg}>
      <Box h={'100vh'} bgColor={AppColors.bgColor}>
        <Box w={'100%'} ref={topbar}>
          <Topbar

            batchId={batchId}
            batchName={batchName}
            rendererId={rendererId}
            rendererOptions={rendererOptions}
            selectedRenderer={selectedRenderer}
            setSelectedRenderer={setSelectedRenderer}
            // onAuditSubmit={() => ioState.on()}
            updateAuditSheet={updateAuditSheet}
            view={view}
            // disableSubmit={isSubmitDisabled}
            lastSaved={lastSaved}
            onChange={on => {
              if (on) {
                ilState.on();
              } else {
                ilState.off();
              }
            }}
            onRebuttalClick={onRebuttalClick}
            onOpenNotes={onOpenNotes}
            notesDrawerRef={notesDrawerRef}
            filterByDate={filterByDate}
            filterSheetsByDate={filterSheetsByDate}
            removeDateFilter={removeDateFilter}
          />
        </Box>

        <Box id="domEl" ref={domEl} onClick={handleSheetClick} >
          <AuditSheet
            height={window.innerHeight - topbar?.current?.clientHeight - footer?.current?.clientHeight}
            scale={scale}
            sheet={sheets[activeSheetIndex]}
            batchId={batchId}
            view={view}
            batch={batch}
            uploadId={uploadId}
            updateAuditSheet={updateAuditSheet}
            updateSheet={updateSheet}
            onCommentClick={onCommentClick}
            onSelectionEnd={(selection, rowData) => setMetaData(prev => ({ ...prev, selection, selectedRowData: rowData }))}
            removeRows={removeRows}
            setSheets={setSheets}
            closeComment={() => icoState.off()}
            // as of now just add this condition for single audit sheet. Add the batch part later.
            rowFilter={!batch ? SINGLE_AUDIT_SHEET_ROW_FILTER: null}
          />
        </Box>

        <Box w={'100%'} position={'fixed'} bottom={0} ref={footer}>
          <AuditSheetFooter
            view={view}
            onSheetChange={setActiveSheetIndex}
            sheets={sheetNames}
            activeSheetIndex={activeSheetIndex}
            addNewSheet={addNewSheet}
            changeSheetName={changeSheetName}
            onLeftNavigate={onLeftNavigate}
            onRightNavigate={onRightNavigate}
            onZoom={onZoom}
            onDeleteSheet={onDeleteSheet}
          />
        </Box>
        {/* <SubmitModal
          isOpen={isOpen}
          onClose={() => ioState.off()}
          onAuditSubmit={onAuditSubmit}
        /> */}
        <Modal size={'sm'} isOpen={isLoading} isCentered bgColor={'transparent'}>
          <ModalOverlay style={{ backgroundColor: AppColors.lightSkyBlue }} />
          <ModalContent bgColor={'transparent'} shadow={'none'}>
            <ModalBody style={{ alignSelf: 'center' }}>
              <Spinner />
            </ModalBody>
          </ModalContent>
        </Modal>
        <CommentBox
          batch={batch}
          showMenu={isCommentOpen}
          role={CLIENT}
          metaData={metaData}
          currentUpload={currentUpload}
          closeComment={() => icoState.off()}
          users={users}
          sheet={sheets[activeSheetIndex]}
          coords={coords}
        />
      </Box>
    </AccessDenied>)
};
export default withProvider(AuditSheetProvider, AuditSheetContainer);
